import { useEffect, useState, memo } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'next-i18next';
import styles from './resend-code.module.scss';

import ReplayOutlinedIcon from '@material-ui/icons/ReplayOutlined';

const ResendSMSCode = ({ onResendSms, onReCall, resendDelaySeconds }) => {
  const { t } = useTranslation('common');
  const [seconds, setSeconds] = useState(resendDelaySeconds);

  useEffect(() => {
    let timeout;

    if (seconds === 0) {
      clearTimeout(timeout);
    } else {
      timeout = setTimeout(() => {
        setSeconds(seconds => --seconds);
      }, 1000);
    }

    return () => {
      clearTimeout(timeout);
    }
  }, [seconds]);

  const resend = async (scope) => {

    if (scope === 'call') {
      onReCall().then(() => {
        setSeconds(resendDelaySeconds)
      }).catch(err => console.log(err));
    } else {
      onResendSms().then(() => {
        setSeconds(resendDelaySeconds)
      }).catch(err => console.log(err));
    }
  };

  return (
    <div className={styles.root}>
      <Choose>
        <When condition={seconds === 0}>
          {/* <div
            className={styles.resend_link}
            onClick={(e) => { resend('call') }}
          >
            <ReplayOutlinedIcon />
            <span>Повторный звонок</span>
          </div> */}
          <div
            className={styles.resend_link}
            onClick={(e) => { resend() }}
          >
            <ReplayOutlinedIcon />
            <span>Отправить СМС с кодом</span>
          </div>
        </When>
        <Otherwise>
          <div className={styles.resend_info_time}>
            <ReplayOutlinedIcon />
            <span>{t('auth.resendCode')} {seconds} {t('common.measures.seconds')}</span>
          </div>
        </Otherwise>
      </Choose>
    </div>
  )
};

ResendSMSCode.propTypes = {
  onReCall: PropTypes.func,
  onResendSms: PropTypes.func.isRequired,
  resendDelaySeconds: PropTypes.number
};

ResendSMSCode.defaultProps = {
  resendDelaySeconds: 45
};

export default memo(ResendSMSCode);